<div class="po-row">
  <po-widget class="widget-critical po-lg-3 po-mt-2 po-mb-2">
    <div class="po-font-subtitle po-text-center">
      {{ items?.vulnerabilities?.metrics?.critical || "0" }}
    </div>
    <div class="po-text-center">Crítica(s)</div>
  </po-widget>

  <po-widget class="widget-high po-lg-3 po-mt-2 po-mb-2">
    <div class="po-font-subtitle po-text-center">
      {{ items?.vulnerabilities?.metrics?.high || "0" }}
    </div>
    <div class="po-text-center">Alta(s)</div>
  </po-widget>

  <po-widget class="widget-medium po-lg-2 po-mt-2 po-mb-2">
    <div class="po-font-subtitle po-text-center">
      {{ items?.vulnerabilities?.metrics?.medium || "0" }}
    </div>
    <div class="po-text-center">Média(s)</div>
  </po-widget>

  <po-widget class="widget-low po-lg-2 po-mt-2 po-mb-2">
    <div class="po-font-subtitle po-text-center">
      {{ items?.vulnerabilities?.metrics?.low || "0" }}
    </div>
    <div class="po-text-center">Baixa(s)</div>
  </po-widget>

  <po-widget class="widget-undefined po-lg-2 po-mt-2 po-mb-2">
    <div class="po-font-subtitle po-text-center">
      {{ items?.vulnerabilities?.metrics?.undefined || "0" }}
    </div>
    <div class="po-text-center">Indefinida(s)</div>
  </po-widget>
</div>
